import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contextos/AuthContext';
import { Button, Icon, Input } from '../../ui';
import AuthLayout from './AuthLayout';
import styles from './Login.module.css';

/** Página dedicada de login (rota /entrar). */
export default function Login() {
  const { usuario, entrar, esqueciSenha, processando } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [semSenha, setSemSenha] = useState(false);
  const [linkEnviado, setLinkEnviado] = useState(false);

  // Quem já está logado não tem o que fazer aqui.
  useEffect(() => {
    if (usuario) navigate('/dashboard');
  }, [usuario, navigate]);

  const submeter = async () => {
    if (processando) return;
    setErro('');
    if (!email.trim() || !senha) {
      setErro('Informe seu e-mail e sua senha para continuar.');
      return;
    }
    const resultado = await entrar(email.trim(), senha);
    if (resultado.ok) return; // o AuthContext já navega para /dashboard

    // Conta migrada (Google/Firebase) que ainda não definiu senha própria.
    if (resultado.codigo === 'senha_nao_definida') {
      setSemSenha(true);
      return;
    }
    setErro(resultado.mensagem || 'Não foi possível entrar. Tente novamente.');
  };

  const enviarLinkDefinirSenha = async () => {
    if (processando) return;
    await esqueciSenha(email.trim());
    // Confirmação neutra: não revelamos se o e-mail existe ou não.
    setLinkEnviado(true);
  };

  const voltarAoFormulario = () => {
    setSemSenha(false);
    setLinkEnviado(false);
    setSenha('');
  };

  if (semSenha) {
    return (
      <AuthLayout titulo="Falta só definir sua senha" subtitulo="Sua conta existe, mas ainda não tem uma senha própria.">
        <div className={styles.painel}>
          <span className={styles.painelIcone}>
            <Icon nome="lock_reset" tamanho={22} cor="var(--primary)" />
          </span>
          {linkEnviado ? (
            <>
              <p className={styles.painelTexto}>
                Pronto! Se <strong>{email.trim()}</strong> estiver cadastrado, você vai receber um link para definir sua
                senha. Verifique sua caixa de entrada e também a pasta de spam.
              </p>
              <Button variante="suave" tamanho="lg" icone="arrow_back" onClick={voltarAoFormulario}>
                Voltar para o login
              </Button>
            </>
          ) : (
            <>
              <p className={styles.painelTexto}>
                Você provavelmente entrava com o Google. Para continuar, é só criar uma senha: enviamos um link seguro
                para <strong>{email.trim()}</strong> e em um minuto você está dentro.
              </p>
              <Button tamanho="lg" icone="forward_to_inbox" carregando={processando} onClick={enviarLinkDefinirSenha}>
                Enviar link para definir senha
              </Button>
              <button type="button" className={styles.linkDiscreto} onClick={voltarAoFormulario}>
                Voltar e tentar outro e-mail
              </button>
            </>
          )}
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout titulo="Bem-vindo de volta" subtitulo="Entre para ver como está o seu mês.">
      <div className={styles.form}>
        {erro && (
          <div className={styles.alerta} role="alert">
            <Icon nome="error" tamanho={18} cor="var(--error)" />
            <span>{erro}</span>
          </div>
        )}

        <Input
          label="E-mail"
          tipo="email"
          icone="mail"
          valor={email}
          onChange={setEmail}
          placeholder="voce@exemplo.com"
          autoFocus
          onEnter={submeter}
        />
        <Input
          label="Senha"
          tipo="password"
          icone="lock"
          valor={senha}
          onChange={setSenha}
          placeholder="Sua senha"
          onEnter={submeter}
        />

        <div className={styles.linhaOpcoes}>
          <Link to="/recuperar-senha" className={styles.link}>
            Esqueci minha senha
          </Link>
        </div>

        <Button tamanho="lg" icone="login" carregando={processando} onClick={submeter}>
          Entrar
        </Button>

        <p className={styles.trocaFluxo}>
          Ainda não tem conta?{' '}
          <Link to="/criar-conta" className={styles.link}>
            Criar conta
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
